import gridImage from "../assets/img/grid-01.svg";
import logoWhite from "../assets/img/logo-white.png";

export default function SiteRightContent(){
    return (
        <div className="relative items-center hidden w-full min-h-screen bg-brand-950 dark:bg-white/5 lg:grid lg:w-1/2">
        <div className="flex items-center justify-center z-1">
          <div className="absolute right-0 top-0 -z-1 w-full max-w-[250px] xl:max-w-[450px]">
            <img src={gridImage} alt="grid" />
          </div>
          <div className="absolute bottom-0 left-0 -z-1 w-full max-w-[250px] rotate-180 xl:max-w-[450px]">
            <img src={gridImage} alt="grid" />
          </div>

          <div className="flex flex-col items-center max-w-xs">
            <a href="/" className="block mb-4">
              <img src={logoWhite} alt="Logo" />
            </a>
            <p className="text-center text-gray-400 dark:text-white/60">
              DPS Video KYC is a secure digital identity verification process that enables financial institutions to remotely verify customers in real time through live video interaction. By combining facial recognition, document verification, and regulatory checks, DPS Video KYC ensures compliance with KYC and AML requirements while delivering a faster, more convenient onboarding experience for customers.  
            </p>
          </div>
        </div>
      </div>
    );
}